import { CallActionType } from '../..';
import { QueueScheduleBuilder } from './queue-schedule.builder';
var QueueOpeningHoursSettingsBuilder = /** @class */ (function () {
    function QueueOpeningHoursSettingsBuilder() {
        this.queueOpeningHoursSettings = {
            schedule: new QueueScheduleBuilder().build(),
            offHoursAction: {
                type: CallActionType.HANGUP
            }
        };
    }
    QueueOpeningHoursSettingsBuilder.prototype.withSchedule = function (schedule) {
        this.queueOpeningHoursSettings.schedule = schedule;
        return this;
    };
    QueueOpeningHoursSettingsBuilder.prototype.withOffHoursAction = function (offHoursAction) {
        this.queueOpeningHoursSettings.offHoursAction = offHoursAction;
        return this;
    };
    QueueOpeningHoursSettingsBuilder.prototype.build = function () {
        return this.queueOpeningHoursSettings;
    };
    return QueueOpeningHoursSettingsBuilder;
}());
export { QueueOpeningHoursSettingsBuilder };
//# sourceMappingURL=queue-opening-hours-settings.builder.js.map